<template>
  <div><div class="thank-you-container" v-html="message"></div></div>

</template>
<script setup lang="ts">
defineProps<{
  message?: string
}>()
</script>
<style scoped>
.thank-you-container {
    padding: 26px 16px;
    text-align: center;
    min-height: 300px;
    border-radius: 4px;
    color: #f87507;
    background: white;
    box-shadow: 0px -2px 20px -2px rgba(30, 80, 180, 0.1019607843);
    max-width: 600px;
    font-weight: 700;
    margin: auto;
    width: 100%;
    font-size: 18px;
    line-height: normal;
}
</style>
